import { useLayoutEffect } from 'react';

const useLockBodyScroll = (enable = false): void => {
  useLayoutEffect(() => {
    // Get original body overflow
    const originalStyle = window.getComputedStyle(document.body).overflow;

    if (enable) {
      // Prevent scrolling when enabled
      document.body.style.overflow = 'hidden';
    } else {
      // Make sure scroll is enabled when 'enable' is false
      document.body.style.overflow = originalStyle;
    }

    return () => {
      // Only reset if we're unmounting and currently have scroll locked
      if (enable) {
        document.body.style.overflow = originalStyle;
      }
    };
  }, [enable]); // Re-run effect when enable status changes
};

export default useLockBodyScroll;
